(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["suonama-community"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-community-root]');
    if (!root) return;
    const apiPath = root.dataset.apiPath.replace(/\/$/, '');
    const topics = root.querySelector('[data-community-topics]');
    const connection = root.querySelector('[data-community-connection]');
    const notice = root.querySelector('[data-community-notice]');
    const search = root.querySelector('[data-community-search]');
    const category = root.querySelector('[data-community-category]');
    const sort = root.querySelector('[data-community-sort]');
    const loadMore = root.querySelector('[data-load-more]');
    let cursor = '';

    const safe = (value) => {
      const node = document.createElement('span');
      node.textContent = value || '';
      return node.innerHTML;
    };

    const showNotice = (message) => {
      notice.textContent = message;
      notice.hidden = false;
    };

    const renderTopics = (items, append = false) => {
      if (!append) topics.innerHTML = '';
      if (!items.length && !append) {
        showNotice(root.dataset.textEmpty);
        return;
      }
      items.forEach((topic) => {
        const link = document.createElement('a');
        link.className = 'sn-community__topic';
        link.href = `${apiPath}/topics/${encodeURIComponent(topic.slug || topic.id)}`;
        const initials = (topic.author_name || 'S').trim().slice(0, 2).toUpperCase();
        link.innerHTML = `<span class="sn-community__avatar">${safe(initials)}</span><span><span class="sn-community__badge">${safe(topic.category_name)}</span><h3>${safe(topic.title)}</h3><span class="sn-community__topic-meta">${safe(topic.author_name)} · ${safe(topic.updated_label)}</span></span><span class="sn-community__topic-count">${Number(topic.reply_count || 0)} replies<br>${Number(topic.view_count || 0)} views</span>`;
        topics.appendChild(link);
      });
    };

    const loadTopics = async (append = false) => {
      if (!append) {
        notice.hidden = true;
        topics.innerHTML = '<div class="sn-community__skeleton"></div><div class="sn-community__skeleton"></div><div class="sn-community__skeleton"></div>';
      }
      const params = new URLSearchParams({ q: search.value.trim(), category: category.value, sort: sort.value });
      if (append && cursor) params.set('cursor', cursor);
      try {
        const response = await fetch(`${apiPath}/api/topics?${params}`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('community unavailable');
        const data = await response.json();
        renderTopics(Array.isArray(data.topics) ? data.topics : [], append);
        cursor = data.next_cursor || '';
        loadMore.hidden = !cursor;
        connection.textContent = data.status_label || 'Online';
        connection.classList.add('is-online');
      } catch (error) {
        if (!append) topics.innerHTML = '';
        connection.textContent = root.dataset.textOffline;
        connection.classList.remove('is-online');
        showNotice(root.dataset.textOffline);
      }
    };

    let timer;
    search.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => loadTopics(), 350);
    });
    category.addEventListener('change', () => loadTopics());
    sort.addEventListener('change', () => loadTopics());
    loadMore.addEventListener('click', () => loadTopics(true));
    root.querySelectorAll('[data-category-button]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-category-button]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        category.value = button.dataset.categoryButton;
        loadTopics();
      });
    });

    const dialog = root.querySelector('[data-topic-dialog]');
    const openTopic = root.querySelector('[data-open-topic]');
    const topicForm = root.querySelector('[data-topic-form]');
    if (dialog && openTopic && topicForm) {
      openTopic.addEventListener('click', () => dialog.showModal());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      topicForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        const submit = topicForm.querySelector('[data-topic-submit]');
        const status = topicForm.querySelector('[data-form-status]');
        submit.disabled = true;
        status.textContent = root.dataset.textLoading;
        try {
          const response = await fetch(`${apiPath}/api/topics`, { method: 'POST', credentials: 'same-origin', body: new FormData(topicForm), headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('post failed');
          topicForm.reset();
          status.textContent = root.dataset.textPosted;
          window.setTimeout(() => {
            dialog.close();
            status.textContent = '';
            loadTopics();
          }, 900);
        } catch (error) {
          status.textContent = root.dataset.textError;
        } finally {
          submit.disabled = false;
        }
      });
    }

    loadTopics();
  })();

  } catch(e) { console.error(e); }
})();
})();
